export default {
    menuStructureURL: `${process.env.REACT_APP_EDITION_DATA_URL}/content/menu-structure.json`,
    contentBaseURL: `${process.env.REACT_APP_EDITION_DATA_URL}/content`,
    imagesBaseURL: `${process.env.REACT_APP_EDITION_DATA_URL}/content/images`,
    contents: {},
    menuStructure: null,
    loaded: false
}	